module.exports = __webpack_public_path__ + "static/media/student-summary-winteacher.996dc090.png";